/**
 * Orders routing module
 *
 * @version
 * 4.75.0 OAUI-715 Switch orders URL to toggle everyone over to the new interface
 * 4.71.0 OAUI-682 Rebuild list work/lookahead orders page and improve usability
 * 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 * 4.33.0 OAUI-472 Add internal angular routing for view/manage order details
 * 4.31.0 OAUI-453 Set up basic list settings, filters and layout
 * 4.31.0 OAUI-452 Set up basic list orders routing
 * 4.26.0 OAUI-436 Change route for Order Management to use orderIndex
 * 4.26.0 OAUI-418 Hook up API calls for QR Code Order Management page
 * 4.26.0 OAUI-416 Add basic QR code order management route
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2021-2024 Build Centrix
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListV2Component } from './components/list-v2/list-v2.component';
import { ListComponent } from './components/list/list.component';
import { ManageComponent } from './components/manage/manage.component';
import { ReportViewerComponent } from '../../components/report-viewer/report-viewer.component';

const routes: Routes = [
  // @deprecated - Remove list-v1 once we're confident everything works OK
  {
    path: 'list-v1/:orderType',
    component: ListComponent,
  },
  {
    path: 'list/:orderType',
    component: ListV2Component,
  },
  {
    path: 'manage/:orderIndex',
    component: ManageComponent,
  },
  {
    path: 'reports/:type/:orderIndex',
    component: ReportViewerComponent,
  },
  { path: '**', redirectTo: 'list/work', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersRoutingModule {}
